import { render, staticRenderFns } from "./newAddrBook.vue?vue&type=template&id=bcbea8ea&scoped=true&"
import script from "./newAddrBook.vue?vue&type=script&lang=js&"
export * from "./newAddrBook.vue?vue&type=script&lang=js&"
import style0 from "./newAddrBook.vue?vue&type=style&index=0&id=bcbea8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbea8ea",
  null
  
)

export default component.exports